import { render, staticRenderFns } from "./Cidadao.vue?vue&type=template&id=0974015e&"
import script from "./Cidadao.vue?vue&type=script&lang=js&"
export * from "./Cidadao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports